import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

function Radio({ value, children }) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  return (
    <div className="flex items-center">
      <label
        htmlFor={value}
        className="flex items-center font-medium text-gray-900 dark:text-gray-300"
      >
        <input
          id={value}
          type="radio"
          value={value}
          name="default-radio"
          className="!w-[20px] !h-[20px]"
        />
        {children}
      </label>
    </div>
  );
}

export default Radio;
